import { atom } from "jotai"

export const selectedPropertiesRowAtom = atom(0)

if (process.env.NODE_ENV !== "production") {
  selectedPropertiesRowAtom.debugLabel = "selectedPropertiesRowAtom"
}
